import { Component, Input, OnInit } from '@angular/core';

import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { SharedLatestVideosService } from './shared-latest-videos.service';

@Component({
    selector: 'app-shared-latest-videos',
    templateUrl: './recent-videos.component.html',
    styleUrls: ['./recent-videos.component.scss'],
})
export class SharedLatestVideos implements OnInit {
    /**
     * departmentType: ID do departamento
     */
    @Input() departmentType: string;
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    icons = {
        arrowRight: faCaretRight,
    };

    constructor(private latestVideosService: SharedLatestVideosService) {}

    ngOnInit(): void {
        this.lastVideos();
    }

    /**
     * lastVideos() - Buscar últimos vídeos publicados
     */
    lastVideos() {
        //console.log('lastVideos');
        this.latestVideosService.getLastVideos(this.departmentType).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }
}
